import type { ComponentProps } from 'react'

import { Button } from '@gto/ui/button'
import { Link } from '@gto/ui/link'

import type { AlertActionProps } from './alert'

const hasHref = (action: AlertActionProps): action is ComponentProps<typeof Link> =>
  'href' in action

type AlertActionButtonProps = AlertActionProps & {
  isSmScreen: boolean
}

export const AlertActionButton = ({ children, isSmScreen, ...action }: AlertActionButtonProps) => {
  if (hasHref(action)) {
    return <Link {...action}>{children}</Link>
  }

  return (
    <Button
      {...action}
      color="secondary"
      size={isSmScreen ? 'large' : 'small'}
      variant="contained"
    >
      {children}
    </Button>
  )
}
